import { render, staticRenderFns } from "./Tune.vue?vue&type=template&id=20ceb954&"
import script from "./Tune.vue?vue&type=script&lang=js&"
export * from "./Tune.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports